// Treatment categories counted by the Monthly Report. Each procedure in the Procedure master
// is tagged with one (or none) via `reportCategory`; the report counts, per day, the distinct
// patients billed for a procedure in each category. `key` is the report row's field name.
export const REPORT_CATEGORIES = [
  { value: "Implant", label: "Implant Cases", key: "implantCases" },
  { value: "Aligner", label: "Aligner Patients", key: "alignerPatients" },
  { value: "RCT", label: "RCT", key: "rct" },
  { value: "Ortho", label: "New Ortho Cases", key: "newOrthoCases" },
  { value: "Extraction", label: "Extraction", key: "extraction" },
  { value: "SurgicalExtraction", label: "Surgical Extraction", key: "surgicalExtraction" },
  { value: "Cleft", label: "Cleft", key: "cleft" },
  { value: "Filling", label: "Filling", key: "filling" },
  { value: "Scaling", label: "Scaling", key: "scaling" },
  { value: "CrownPreparation", label: "Crown Preparation", key: "crownPreparation" },
  { value: "CD", label: "CD", key: "cd" },
  { value: "Pulpotomy", label: "Pulpotomy", key: "pulpotomy" },
  { value: "RPD", label: "RPD", key: "rpd" },
  { value: "Myofunctional", label: "Myofunctional Appliance", key: "myofunctionalAppliance" },
];

// Used only for procedures without a reportCategory (the API doesn't store the field yet):
// guess from the procedure name. Order matters — Surgical Extraction before Extraction.
const NAME_RULES = [
  ["SurgicalExtraction", /surgical.*extract|impaction/i],
  ["Extraction", /extract/i],
  ["Implant", /implant/i],
  ["Aligner", /aligner/i],
  ["RCT", /\brct\b|root canal/i],
  ["Pulpotomy", /pulpotomy/i],
  ["Myofunctional", /myofunctional/i],
  ["Ortho", /ortho/i],
  ["Cleft", /cleft/i],
  ["Filling", /filling|restoration/i],
  ["Scaling", /scaling|prophylaxis/i],
  ["CrownPreparation", /crown/i],
  ["RPD", /\brpd\b|partial denture/i],
  ["CD", /\bcd\b|complete denture/i],
];

export const categoryOf = (procedure) =>
  procedure.reportCategory || NAME_RULES.find(([, re]) => re.test(procedure.procedureName || ""))?.[0] || null;
